import { handlePostAction } from "../../../utils/event-api-invoke";
import { getBranchCostConfigAPIPostSchema, getBranchCostConfigAPIDeleteSchema, getBranchCostConfigAuditInfoSchema } from "../create/Schema";

let _isError = false;

const _getPreviousState = (data) => {
  try {
    let _prevState = {};

    _prevState.MinuteCostDay = data?.MinuteCostDay || 0;
    _prevState.MinuteCostNight = data?.MinuteCostNight || 0;
    _prevState.MinuteCostHoliday = data?.MinuteCostHoliday || 0;
    _prevState.MinuteCostHolidayNight = data?.MinuteCostHolidayNight || 0;
    _prevState.VisitCost = data?.VisitCost || 0;
    _prevState.VisitCostHoliday = data?.VisitCostHoliday || 0;
    _prevState.VisitCostHolidayNight = data?.VistCostHolidayNight || 0;
    _prevState.VisitCostNight = data?.VistCostNight || 0;
    _prevState.BranchName = data?.Branch?.label || "";

    return JSON.stringify(_prevState);
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const _getCurrentState = (data) => {
  try {
    let _currentState = {};

    _currentState.MinuteCostDay = data?.MinuteCostDay || 0;
    _currentState.MinuteCostNight = data?.MinuteCostNight || 0;
    _currentState.MinuteCostHoliday = data?.MinuteCostHoliday || 0;
    _currentState.MinuteCostHolidayNight = data?.MinuteCostHolidayNight || 0;
    _currentState.VisitCost = data?.VisitCost || 0;
    _currentState.VisitCostHoliday = data?.VisitCostHoliday || 0;
    _currentState.VisitCostHolidayNight = data?.VistCostHolidayNight || 0;
    _currentState.VisitCostNight = data?.VistCostNight || 0;
    _currentState.BranchName = data?.Branch?.label || "";

    return JSON.stringify(_currentState);
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getAuditInfo = (data, auditConfig) => {
  try {
    let _auditSchema = getBranchCostConfigAuditInfoSchema();
    let _isDeleted = data?.Deleted;

    _auditSchema.auditInfo[0].shortDesc = data?.Branch.label;
    _auditSchema.auditInfo[0].currentState = (_isDeleted) ? "{}" : _getCurrentState(data); //If the record is deleted, previousState will be available. The currentState will be available for creation.
    if (auditConfig.editBranchId) {
      _auditSchema.auditInfo[0].LocationKey = auditConfig.editBranchId;
      _auditSchema.auditInfo[0].Action = _isDeleted ? "DELETE" : "EDIT";
      _auditSchema.auditInfo[0].previousState = _isDeleted ? _getPreviousState(data) : _getPreviousState(auditConfig.formdata); //For single tables during record deletion send data to previous state instead of form data
    } else {
      _auditSchema.auditInfo[0].Action = "CREATE";
    }

    return _auditSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getPostPayload = (data, config) => {
  try {

    let _isDeleted = data?.Deleted;
    let _postSchema = {};
    if (_isDeleted) {
      _postSchema = getBranchCostConfigAPIDeleteSchema(config.countryCode, config.businessCode);

      _postSchema.branchcostConfig[0].BranchId = config.editBranchId;
      _postSchema.branchcostConfig[0].Id = config.editBranchId;
      _postSchema.branchcostConfig[0].Deleted = _isDeleted;

    } else {
      _postSchema = getBranchCostConfigAPIPostSchema(config.countryCode, config.businessCode);

      _postSchema.branchcostConfig[0].MinuteCostDay = data?.MinuteCostDay || 0;
      _postSchema.branchcostConfig[0].MinuteCostNight = data?.MinuteCostNight || 0;
      _postSchema.branchcostConfig[0].MinuteCostHoliday = data?.MinuteCostHoliday || 0;
      _postSchema.branchcostConfig[0].MinuteCostHolidayNight = data?.MinuteCostHolidayNight || 0;
      _postSchema.branchcostConfig[0].VisitCost = data?.VisitCost || 0;
      _postSchema.branchcostConfig[0].VisitCostHoliday = data?.VisitCostHoliday || 0;
      _postSchema.branchcostConfig[0].VistCostHolidayNight = data?.VistCostHolidayNight || 0;
      _postSchema.branchcostConfig[0].VistCostNight = data?.VistCostNight || 0;
      _postSchema.branchcostConfig[0].BranchNumber = data?.Branch?.id || "";
      _postSchema.branchcostConfig[0].BranchName = (data?.Branch?.label.split("-")[1]).trim() || "";

      if (config.editBranchId) {
        _postSchema.branchcostConfig[0].BranchId = config.editBranchId;
        _postSchema.branchcostConfig[0].Id = config.editBranchId;
      }
    }

    return _postSchema;

  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const saveBranchCostConfig = async (data, uihandler) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  const {
    EditBranchId: editBranchId,
    settingsConfig: { businessCode, countryCode },
    formdata
  } = uihandler;
  try {
    let _auditInfo = getAuditInfo(data, { editBranchId, formdata });
    let _postPayload = getPostPayload(data, { editBranchId, businessCode, countryCode });

    let _postRequest = { ..._postPayload, ..._auditInfo };

    let res = await handlePostAction(_postRequest, "branchcostconfig");
    if (res && res.status && res.status === 200) {
      if (res.data.errorNumber > 0) {
        _isError = true;
        status.errorMessage = res.data.errorDescription;
      } else {
        status.responseStatus = res.status;
      }
    }

  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

export { saveBranchCostConfig};
